/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import RecorderV3 from '../../recorder';
import { getToken } from '../../lib/localStorageHandler';
import { addFile } from '../library/librarySlice';
import { addFileToUploads, removeFileFromUploads } from '../upload/uploadSlice';

let recorderV3: RecorderV3;

export const initializeRecorder = createAsyncThunk(
  'recorder/initializeRecorder',
  async (
    {
      teamId,
      folderId,
      settings,
    }: {
      teamId: string;
      folderId: string;
      settings?: ConstructorParameters<typeof RecorderV3>[0]['settings'];
    },
    { rejectWithValue, dispatch }
  ) => {
    const token = getToken();

    if (!token) return rejectWithValue('Token not found');
    recorderV3 = new RecorderV3({
      apiKey: token,
      teamId,
      folderId,
      settings: {
        ...settings,
      },
    });
    recorderV3.on('ready', (event) => {
      console.log('Recorder ready', event.detail);
    });
    recorderV3.on('stopped', (event) => {
      const { folderId: uploadingFileId, fileId } = event.detail;

      dispatch(
        addFileToUploads({
          folderId: uploadingFileId,
          fileId,
          fileName: `Recording-${new Date().toISOString()}`,
          progress: 0,
        })
      );
    });
    recorderV3.on('error', (event) => {
      console.error('Recorder error', event.detail);
    });
    recorderV3.on('uploaded', (event) => {
      const { folderId: uploadingFileId } = event.detail;
      const { _id: fileId } = event.detail.file;
      dispatch(removeFileFromUploads({ folderId: uploadingFileId, fileId }));
      dispatch(addFile(event.detail.file));
    });
    await recorderV3.initialize();
    return undefined;
  }
);
